import first from 'lodash/first'
import type { DocumentNode } from 'graphql/language'
import { fetch as jsonFetch } from './index'
import { jsonStringify } from '../json'
export type FetchResult<T> = {
  data: T
  error: any
  response: any
}

export type Variables<TInput> = {
  filter?: Record<any, any>
  input?: Partial<TInput>
  options?: {
    skip?: number
    limit?: number
    sort?: Record<any, any>
  }
}
export type GraphqlFetchArgs<TInput = any> = {
  query?: string | DocumentNode
  variables?: Variables<TInput>
  accessToken?: string
  throwOnError?: boolean
  rootUrl?: string
}

export async function graphqlFetch<TResult = any, TInput = any>({
  query,
  variables,
  accessToken,
  throwOnError = true,
  rootUrl,
}: GraphqlFetchArgs<TInput>): Promise<FetchResult<TResult>> {
  const gql = '/graphql?tenantId=DFT'

  if (typeof query !== 'string' && query?.loc?.source?.body) {
    query = query.loc.source.body
  }

  const headers: Record<string, string> = {
    authorization: accessToken,
  }

  const url = `${rootUrl}${gql}`

  const response = await jsonFetch(url, {
    method: 'POST',
    headers,
    body: jsonStringify({
      query,
      variables,
    }),
  })

  // If we should throw on error and there is an error
  if (throwOnError) {
    // If come from the graphql errors
    if (response.errors) {
      const firstError: any = first(response.errors)
      const exception = firstError?.extensions?.exception
      const message = firstError.message

      if (!exception) throw new Error(`GRAPHQL ERROR: ${message}`)

      throw new Error(message, exception.code)
    }

    // If come from the base error of body
    if (response?.error) throw new Error(response?.error)
  }

  return {
    data: Object.values(response.data)[0] as TResult,
    error: response.errors,
    response,
  }
}
